import axios from "../../config/interceptor";

export const postConfiguration = async (data) => {
  try {
    const response = await axios.post(
      "/lambda/v1/business/configuration",
      data
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const getConfiguration = async (business_id) => {
  try {
    let link = `/lambda/v1/business/configuration/${business_id}`;
    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};
